export default "__VITE_ASSET__DescLyCV__"